# Currently Not For Code Review
rjm.ui.ChartBuilderTypeSelectorView = Backbone.View.extend(
  initialize: (options) ->
    if not options or not options.chartModel
    	throw "InvalidConstructorArgs - ChartBuilderTypeSelectorView"
    _.bindAll this, "render"
    @model = options.chartModel
    return

  render: ->
    $(@el).html ich.chartBuilderTypeSelector(@model.attributes)
    this
)